import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Form, Grid, Header, Message, Segment } from 'semantic-ui-react';

import { clienteApi } from 'src/api';
import { Contexto } from 'src/contexto';
import { Plan } from 'src/modulos/Horarios/tipos';
import { nombreCompletoConNombresPrimero } from 'src/utilidades';

interface AlumnoDTO {
    id: string;
    nombre: {
        primerNombre: string;
        nombresSecundarios: string;
        apellidoPaterno: string;
        apellidoMaterno: string;
    };
    plan: Plan;
}

interface Alumno extends AlumnoDTO {
    nombreCompleto: string;
}

interface AlumnoInhabilitado extends Alumno {
    numeroDeMatricula: number;
    estado: 'vigente' | 'horario-pendiente' | 'nulo';
}

interface State {
    idAlumno: string;
    idAlumnoInhabilitado: string;
    alumnos: Array<Alumno>;
    alumnosInhabilitados: Array<AlumnoInhabilitado>;
}

class BuscarAlumnos extends React.Component<RouteComponentProps<{}>, State> {
    public static readonly contextType = Contexto;
    public readonly context!: React.ContextType<typeof Contexto>;

    public state: State = {
        idAlumno: '',
        idAlumnoInhabilitado: '',
        alumnos: [],
        alumnosInhabilitados: [],
    };

    private readonly puedeVerInhabilitados = this.context.usuarioActual.tieneAlgunaDeEstasFunciones(
        'administrador_cursos',
    );

    public async componentDidMount() {
        await this.obtenerAlumnos();
    }

    public render() {
        const { history } = this.props;
        const { alumnos, alumnosInhabilitados } = this.state;

        const mostrarInhabilitados = this.puedeVerInhabilitados && alumnosInhabilitados.length > 0;

        return (
            <Grid columns='equal'>
                <Grid.Column>
                    <Segment>
                        <Header content='Inscribir cursos' />
                        <Form
                            onSubmit={() => {
                                history.push(`/horarios/inscribir/${this.state.idAlumno}`);
                            }}
                        >
                            <Form.Select
                                label='Seleccione al alumno'
                                options={alumnos.map(alu => ({
                                    key: alu.id,
                                    value: alu.id,
                                    text: `${alu.nombreCompleto} (${nombrePlan[alu.plan]})`,
                                }))}
                                value={this.state.idAlumno}
                                onChange={(_e, { value }) => {
                                    this.setState({ idAlumno: value as string });
                                }}
                                search
                                deburr
                                noResultsMessage='No se encontraron resultados'
                                fluid
                                loading={alumnos.length === 0}
                            />

                            <Form.Button content='Inscribir asignaturas' primary />
                        </Form>
                    </Segment>
                </Grid.Column>

                <Grid.Column>
                    {mostrarInhabilitados && (
                        <>
                            <Segment color='red' attached='top'>
                                <Header content='Alumnos con horario pendiente' />

                                <Form
                                    onSubmit={() => {
                                        history.push(
                                            `/horarios/inscribir/${this.state.idAlumnoInhabilitado}`,
                                        );
                                    }}
                                >
                                    <Form.Select
                                        label='Seleccione al alumno'
                                        options={alumnosInhabilitados.map(alu => {
                                            return {
                                                key: alu.id,
                                                value: alu.id,
                                                text: `${alu.nombreCompleto}`,
                                                content: (
                                                    <span
                                                        style={
                                                            alu.estado === 'horario-pendiente'
                                                                ? { color: '#aa0000' }
                                                                : {}
                                                        }
                                                    >
                                                        {alu.nombreCompleto}
                                                    </span>
                                                ),
                                            };
                                        })}
                                        value={this.state.idAlumnoInhabilitado}
                                        onChange={(_e, { value }) => {
                                            this.setState({
                                                idAlumnoInhabilitado: value as string,
                                            });
                                        }}
                                        search
                                        deburr
                                        noResultsMessage='No se encontraron resultados'
                                        fluid
                                        loading={alumnosInhabilitados.length === 0}
                                    />

                                    <Form.Button content='Ir al horario' primary />
                                </Form>
                            </Segment>
                            <Message attached='bottom'>
                                <p>
                                    Estos {alumnosInhabilitados.length} alumnos tienen horario
                                    pendiente y requieren intervención manual.
                                </p>
                                <p>Los alumnos en negro están nulos.</p>
                                <p>
                                    Los alumnos en rojo tienen cursos inscritos de asignaturas ya no
                                    contratadas. Estas deben desinscribirse para aparecer en el
                                    listado de la izquierda.
                                </p>
                            </Message>
                        </>
                    )}
                </Grid.Column>
            </Grid>
        );
    }

    private async obtenerAlumnos() {
        const ordenarYMapear = <A extends AlumnoDTO>(resultados: { alumnos: A[] }) =>
            resultados.alumnos
                .map(alu => ({
                    ...alu,
                    nombreCompleto: nombreCompletoConNombresPrimero(alu.nombre),
                    plan: alu.plan,
                }))
                .sort((a, b) => a.nombreCompleto.localeCompare(b.nombreCompleto));

        try {
            const alumnosHabilitados = ordenarYMapear(
                await clienteApi.ejecutar('todosLosAlumnosQueInscribenCursos'),
            );
            const alumnosInhabilitados = this.puedeVerInhabilitados
                ? ordenarYMapear(
                      await clienteApi.ejecutar('alumnosInhabilitadosConCursosInscritos'),
                  )
                : [];

            this.setState({
                alumnos: alumnosHabilitados,
                alumnosInhabilitados,
            });
        } catch (error) {
            this.context.mostrarModalError(error);
        }
    }
}

export default BuscarAlumnos;

const nombrePlan: Record<Plan, string> = {
    'anual': 'anual',
    'intensivo': 'intensivo',
    'intensivo-vespertino': 'intensivo vesp.',
};



// WEBPACK FOOTER //
// ./src/modulos/Horarios/TomaDeHorarios/componentes/BuscarAlumnos/index.tsx